import { useEffect, useState, useCallback } from "react";
import { read } from "@/lib/storage";

export function useStore(key) {
  const [val, setVal] = useState(() => read(key));
  useEffect(() => {
    const h = (e) => {
      if (!e.detail || e.detail.key === key) setVal(read(key));
    };
    window.addEventListener("lf-storage", h);
    return () => window.removeEventListener("lf-storage", h);
  }, [key]);
  return val;
}

export function useAsync() {
  const [state, setState] = useState({ loading: false, error: null });
  const run = useCallback(async (fn) => {
    setState({ loading: true, error: null });
    try {
      const r = await fn();
      setState({ loading: false, error: null });
      return r;
    } catch (e) {
      setState({ loading: false, error: e });
      return null;
    }
  }, []);
  return [state, run];
}

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-";
export const fmtMinutes = (m) => {
  const h = Math.floor(m / 60);
  const mm = Math.round(m % 60);
  return h > 0 ? `${h} j ${mm} m` : `${mm} m`;
};
export const dayKey = (d) => {
  const x = new Date(d);
  return `${x.getFullYear()}-${String(x.getMonth() + 1).padStart(2, "0")}-${String(x.getDate()).padStart(2, "0")}`;
};
